import { STORES } from "../../../data/page_types";

export default () => window.location.host.split(".").length === 3 && (
  window.location.host.split(".")[0] === STORES ||
  window.location.host.split(".")[0] === "test-stores" ||
  window.location.port === "8083"
)
